// extracted by mini-css-extract-plugin
export default {"freeTextDescription":"style--freeTextDescription--cefff0"};